import React from 'react';
import Newnabar from '../components/shared/Newnabar';
import SoloConnectFooter from '../components/shared/SoloConnectFooter';
import SoloConnectMobileFooter from '../components/shared/SoloConnectMobileFooter';
import Travelsafelyhero from '../components/safety-tips/Travelsafelyhero';
import Safetytipsgrid from '../components/safety-tips/Safetytipsgrid';
import SEO from '../components/shared/SEO';

export default function SafetyTips() {


  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden bg-white pt-16">
      <SEO
        title="Safety Tips | SoloConnect"
        description="Your safety is our priority. Follow these simple travel tips to enjoy a worry-free, secure, and memorable journey with SoloConnect."
        keywords="safety, travel tips, secure journey, SoloConnect"
      />
      <Newnabar />

      <main className="flex-grow">

    <Travelsafelyhero />
    <Safetytipsgrid />
     
       
      </main>

      <div className="hidden md:block">
        <SoloConnectFooter />
      </div>

      <div className="block md:hidden">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
